var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A66C2",
    d: "M32 16.04C32 7.186 24.832 0 16 0S0 7.186 0 16.04c0 7.764 5.504 14.228 12.8 15.72V20.851H9.6V16.04h3.2v-4.01c0-3.096 2.512-5.614 5.6-5.614h4v4.812h-3.2c-.88 0-1.6.722-1.6 1.604v3.208h4.8v4.812h-4.8V32c8.08-.802 14.4-7.635 14.4-15.96"
  })));
};
export default SvgFacebook;